var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelSvgrepocom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.7429 46.05L25.5359 40.2V83.4269C25.5363 83.8966 25.6292 84.3615 25.8092 84.7952C25.9893 85.2289 26.2531 85.6229 26.5854 85.9547C26.9177 86.2865 27.3122 86.5495 27.7462 86.7289C28.1802 86.9082 28.6453 87.0003 29.1149 87H86.4149C86.885 87.0011 87.3507 86.9096 87.7854 86.7306C88.2201 86.5516 88.6153 86.2887 88.9483 85.9568C89.2812 85.6249 89.5455 85.2307 89.726 84.7966C89.9064 84.3625 89.9995 83.8971 89.9999 83.4269V67.5L58.7429 46.05Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.7429 9H29.1149C28.6453 8.99961 28.1802 9.09171 27.7462 9.27106C27.3122 9.45041 26.9177 9.71348 26.5854 10.0453C26.2531 10.377 25.9893 10.771 25.8092 11.2048C25.6292 11.6385 25.5363 12.1034 25.5359 12.573V28.5L58.7429 48L76.3259 53.85L89.9999 48V28.5L58.7429 9Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.5359 28.5H58.7429V48H25.5359V28.5Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.1,
    d: "M49.3019 24.6H25.5359V73.35H49.3019C50.2489 73.3453 51.1559 72.9676 51.8264 72.2988C52.4968 71.63 52.8768 70.724 52.8839 69.777V28.173C52.8768 27.226 52.4968 26.3199 51.8264 25.6511C51.1559 24.9824 50.2489 24.6047 49.3019 24.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M47.3489 26.55H25.5359V75.3H47.3489C48.2959 75.2953 49.2029 74.9177 49.8734 74.2489C50.5439 73.5801 50.9238 72.674 50.9309 71.7271V30.123C50.9238 29.1761 50.5439 28.27 49.8734 27.6012C49.2029 26.9324 48.2959 26.5548 47.3489 26.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M47.3489 26.55H25.5359V71.4H47.3489C48.2959 71.3953 49.2029 71.0177 49.8734 70.3489C50.5439 69.6801 50.9238 68.774 50.9309 67.827V30.123C50.9238 29.1761 50.5439 28.27 49.8734 27.6012C49.2029 26.9324 48.2959 26.5548 47.3489 26.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M45.3959 26.55H25.5359V71.4H45.3959C46.3429 71.3953 47.2499 71.0177 47.9204 70.3489C48.5908 69.6801 48.9708 68.774 48.9779 67.827V30.123C48.9708 29.1761 48.5908 28.27 47.9204 27.6012C47.2499 26.9324 46.3429 26.5548 45.3959 26.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.582 26.5501H45.396C46.3447 26.5493 47.2549 26.9252 47.9266 27.5951C48.5982 28.2651 48.9764 29.1744 48.978 30.1231V65.8771C48.9764 66.8257 48.5982 67.735 47.9266 68.405C47.2549 69.075 46.3447 69.4508 45.396 69.4501H9.582C9.11214 69.4508 8.64673 69.359 8.21237 69.1799C7.77802 69.0007 7.38323 68.7377 7.05057 68.4059C6.71791 68.074 6.4539 67.6799 6.27364 67.246C6.09338 66.8121 6.00039 66.3469 6 65.8771V30.1231C6.00039 29.6532 6.09338 29.188 6.27364 28.7541C6.4539 28.3202 6.71791 27.9261 7.05057 27.5943C7.38323 27.2624 7.77802 26.9994 8.21237 26.8202C8.64673 26.6411 9.11214 26.5493 9.582 26.5501Z",
    fill: "url(#paint0_linear_757_2589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M17.1001 59.619L24.6331 47.967L17.7331 36.381H23.2741L27.0391 43.8C27.3871 44.502 27.6391 45.024 27.7531 45.372H27.8041C28.0501 44.808 28.3111 44.265 28.5841 43.734L32.6101 36.393H37.7101L30.6331 47.913L37.8901 59.628H32.4631L28.1131 51.495C27.9111 51.1453 27.7395 50.779 27.6001 50.4H27.5281C27.4013 50.7692 27.2321 51.1226 27.0241 51.453L22.5451 59.619H17.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M86.4179 9.00001H58.7429V28.5H89.9999V12.573C89.9995 12.1031 89.9065 11.638 89.7263 11.2041C89.546 10.7702 89.282 10.376 88.9494 10.0442C88.6167 9.71238 88.2219 9.44937 87.7875 9.2702C87.3532 9.09103 86.8878 8.99922 86.4179 9.00001Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M58.7429 48H89.9999V67.5H58.7429V48Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_757_2589",
    x1: 13.482,
    y1: 23.7421,
    x2: 41.496,
    y2: 72.2581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelSvgrepocom2);
export default __webpack_public_path__ + "static/media/excel_svgrepo.com (2).6b5c85e727177767e6d491519611c350.svg";
export { ForwardRef as ReactComponent };